import request from "@/utils/request";

export function getInviteProgress() {
  return request({
    url: "/User/Invite/GetInviteProgress",
    method: "get",
  });
}
